import { ɵɵdefineInjectable, Injectable, EventEmitter, Component, ViewChild, Input, Output, NgModule } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ckeditor/ckeditor5-angular';
import * as ɵngcc2 from '@angular/forms';

const _c0 = ["editor"];
class RxNxcCkeditorService {
    constructor() { }
}
RxNxcCkeditorService.ɵfac = function RxNxcCkeditorService_Factory(t) { return new (t || RxNxcCkeditorService)(); };
RxNxcCkeditorService.ɵprov = ɵɵdefineInjectable({ factory: function RxNxcCkeditorService_Factory() { return new RxNxcCkeditorService(); }, token: RxNxcCkeditorService, providedIn: "root" });
RxNxcCkeditorService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RxNxcCkeditorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

// https://github.com/ckeditor/ckeditor5-adapter-ckfinder/blob/master/src/uploadadapter.js#L147
// const url = this.editor.config.get( 'ckfinder.uploadUrl' );
// if ( !url ) {
//     return;
// }
// const uploadUrl = `http://localhost:3000/Webapi/v1/ckeditor-img-upload`;
// const uploadKeyName = 'upload-drqa-files';
// const uploadReqHeaders = {
//     //  'Content-Type': 'application/json',
//     //  'X-CSRF-TOKEN': 'CSRF-Token',
//     // 10年token
//     //  "expiredDatetime": "2031-04-18T07:13:46.954Z",
//     Authorization: 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEwMCIsIm5hbWUiOiJBcHDmk43kvZzlk6EiLCJlbWFpbCI6InJlYWxzdW4uNWdoaXNAZ21haWwuY29tIiwicm9sZSI6InVzZXIiLCJhbGxSb2xlcyI6W10sImV4cGlyZXNJbiI6MzE1MzYwMDAwLCJpYXQiOjE2MTg5MDI4MjYsImV4cCI6MTkzNDI2MjgyNn0.PRCuF322kEGcNnhT2Zy65O7czxtwZPdpSclisgFHllAsCSZQQr0fw5nuSYUgeR0QZDxPd8kPM1KPVPZJ6VOGFXq-RV08E8jxVOaagBLdx_heNfRYLHwRcHuCIt4J5XfPu4ZycRVFHOvQQHlRXivd0Zz7v8iVZWQpxycTJU-LQT903ne5sepYQsrruIPkNu-8mexhSkO3qA7JEP44dymhmA-MIePQ_hnsDdWnZNDDgRmj4pYmn0MUpMtKnX1jJBha4pSxrGdxA-40RP_PU2a22b8MBqLTClVCt11FkFcexV0GJMsj0diEgi70Kksq97NOrxecXRfHt4Azy5AkmYwzKw',
//     __realsun_doctorId: 'a0002',
//     __realsun_doctorName: 'WANG-SHO-MING22',
//     multerUploadType: 'DRQA'
// };
// export class FileUploadAdapter0 {
//     loader;
//     http: HttpClient;
//     editor;
//     constructor(loader, editor) {
//         this.loader = loader;
//         this.editor = editor;
//         // 获取传入的http模块
//         this.http = this.editor.config.get('http');
//     }
//     headers(token){
//         return new HttpHeaders({
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}`
//            });
//     }
//     upload() {
//         const data = new FormData();
//         // 表单name为file，和后端app.js中的 req.files.file 相对应
//         data.append('upload-drqa-files', this.loader.file);
//         return new Promise((resolve, reject) => {
//             let options={
//                 headers: new HttpHeaders( {
//                     'Content-Type': 'application/json',
//                   //  'X-CSRF-TOKEN': 'CSRF-Token',
//                     Authorization: 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEiLCJuYW1lIjoiUmljaGFyZCBId2FuZyIsImVtYWlsIjoicmljaGh3YW5nODg2QGdtYWlsLmNvbSIsInJvbGUiOiJhZG1pbiIsImFsbFJvbGVzIjpbeyJuYW1lIjoiYWRtaW4ifSx7Im5hbWUiOiJ1c2VyIn1dLCJleHBpcmVzSW4iOjM2MDAsImlhdCI6MTYxODg5MDAwNSwiZXhwIjoxNjE4ODkzNjA1fQ.tesVuK-rlj5gzmCh_W3Sgzgb46IwYEW-FlkN5K5Q1PyzH5jR_JScBgeTDzTOuIMTjKS145ab915Vmelen-L3-8yvd9hCXsueKbIjF90m-apGItIyyGdtNu5U44ELnTyHIhFZ39pit_2mcsQRk6z9gJ2FMnl8-6HEfnbkGduVd0tnO1uj99rxTFLBoFfzy5sYmwZvOF1p-VDtl6gPGWeqlivLKqE-Kt2xIctn3bwEbwTU64pUPUf8rS9PgeHkRg1OW7ZF8UWof7LWGhOtLe2XzhblCsjLuCEdsSgfxbg5Y2b8uDy9sjTrBzr7HOvGdK2e1zXHsqygy8938QoRntZ1YA',
//                     __realsun_doctorId:'a0002',
//                     __realsun_doctorName:'WANG-SHO-MING22',
//                     multerUploadType:'DRQA'
//                 })
//             }
//             this.http.post(
//                     'http://localhost:3000/Webapi/v1/ckeditor-img-upload',
//                     data,
//                     options
//                 )
//                 .subscribe(
//                     (resp) => {
//                         // console.log("TCL-MESSAGE ~ file: fileupload.ckeditor.ts ~ line 22 ~ FileUploadAdapter ~ returnnewPromise ~ resp", resp);
//                        // console.log(resp)
//                         resolve(resp);
//                         // resolve({
//                         //     default: resp.default
//                         // });
//                     },
//                     (err) =>{
//                         // console.error("TCL-MESSAGE ~ file: fileupload.ckeditor.ts ~ line 29 ~ FileUploadAdapter ~ returnnewPromise ~ err", err);
//                         reject(err)
//                     } );
//         });
//     }
//     abort() {
//     }
// }
class FileUploadAdapter {
    constructor(loader, editor) {
        this.loader = loader;
        this.editor = editor;
        // The file loader instance to use during the upload.
        this.loader = loader;
        this.setting = this.editor.config.get('RxNxcSetting');
        //this.setting = this.editor.config.RxNxcSetting;  --> 不可直接用!!
        // console.log("TCL-MESSAGE ~ file: fileupload.ckeditor.ts ~ line 97 ~ FileUploadAdapter ~ constructor ~ this.setting", this.setting);
    }
    // Starts the upload process.
    upload() {
        return this.loader.file
            .then(file => new Promise((resolve, reject) => {
            this._initRequest();
            this._initListeners(resolve, reject, file);
            this._sendRequest(file);
        }));
    }
    // Aborts the upload process.
    abort() {
        if (this.xhr) {
            this.xhr.abort();
        }
    }
    // Initializes the XMLHttpRequest object using the URL passed to the constructor.
    _initRequest() {
        const xhr = this.xhr = new XMLHttpRequest();
        // Note that your request may look different. It is up to you and your editor
        // integration to choose the right communication channel. This example uses
        // a POST request with JSON as a data structure but your configuration
        // could be different.
        xhr.open('POST', this.setting.uploadUrl, true);
        xhr.responseType = 'json';
    }
    // Initializes XMLHttpRequest listeners.
    _initListeners(resolve, reject, file) {
        const xhr = this.xhr;
        const loader = this.loader;
        const genericErrorText = `Couldn't upload file: ${file.name}.`;
        xhr.addEventListener('error', () => reject(genericErrorText));
        xhr.addEventListener('abort', () => reject());
        xhr.addEventListener('load', () => {
            const response = xhr.response;
            // This example assumes the XHR server's "response" object will come with
            // an "error" which has its own "message" that can be passed to reject()
            // in the upload promise.
            //
            // Your integration may handle upload errors in a different way so make sure
            // it is done properly. The reject() function must be called when the upload fails.
            if (!response || response.error) {
                return reject(response && response.error ? response.error.message : genericErrorText);
            }
            // If the upload is successful, resolve the upload promise with an object containing
            // at least the "default" URL, pointing to the image on the server.
            // This URL will be used to display the image in the content. Learn more in the
            // UploadAdapter#upload documentation.
            // console.log('its down!!',response.url)
            /** 20210423 這裏才是最後上傳後的地方, 要主動呼叫getData, 其中的值,才有機會自動更新!! */
            const data = this.editor.getData();
            const inst = this.editor.config.get('RxNxcInst');
            inst.setValue(data);
            resolve({
                default: response.url
            });
        });
        // uploadReqHeaders.keys().forEach(v => {
        Object.keys(this.setting.uploadReqHeaders).forEach(v => {
            // console.log("TCL-MESSAGE ~ file: fileupload.ckeditor.ts ~ line 146 ~ FileUploadAdapter ~ uploadReqHeaders.keys ~ v", v);
            // // console.log("TCL-MESSAGE ~ file: fileupload.ckeditor.ts ~ line 146 ~ FileUploadAdapter ~ uploadReqHeaders.keys ~ uploadReqHeaders.get(v)", uploadReqHeaders.get(v));
            // console.log("TCL-MESSAGE ~ file: fileupload.ckeditor.ts ~ line 146 ~ FileUploadAdapter ~ uploadReqHeaders.keys ~ uploadReqHeaders.get(v)", uploadReqHeaders[v]);
            //  xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            // xhr.setRequestHeader(v, uploadReqHeaders.get(v));
            xhr.setRequestHeader(v, this.setting.uploadReqHeaders[v]);
        });
        // Upload progress when it is supported. The file loader has the #uploadTotal and #uploaded
        // properties which are used e.g. to display the upload progress bar in the editor
        // user interface.
        if (xhr.upload) {
            xhr.upload.addEventListener('progress', evt => {
                // console.log("TCL-MESSAGE ~ file: fileupload.ckeditor.ts ~ line 175 ~ FileUploadAdapter ~ //uploadReqHeaders.keys ~ evt", evt);
                if (evt.lengthComputable) {
                    loader.uploadTotal = evt.total;
                    loader.uploaded = evt.loaded;
                }
            });
        }
    }
    // Prepares the data and sends the request.
    _sendRequest(file) {
        // Prepare the form data.
        const data = new FormData();
        // data.append( 'upload', file );
        data.append(this.setting.uploadKeyName, file);
        // Important note: This is the right place to implement security mechanisms
        // like authentication and CSRF protection. For instance, you can use
        // XMLHttpRequest.setRequestHeader() to set the request headers containing
        // the CSRF token generated earlier by your application.
        // Send the request.
        this.xhr.send(data);
    }
}
function RxNxcUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        // 将 editor 对象也注入其中
        return new FileUploadAdapter(loader, editor);
    };
}

// 改由在 rx-nxc-ckedirot.module.ts 中的 forRoot , 在 使用的app 中指定
/**
 *
 * EX:
 *
 *
 * <lib-rx-nxc-ckeditor
    ngDefaultControl name='testdata'
    [uploadUrl] = "uploadUrl"
    [(value)]="testdata"
    (change)="onChange($event)"
  >
 */
class RxNxcCkeditorComponent {
    constructor() {
        //public Editor = ClassicEditor;
        this.Editor = RsCustomCKEditor;
        /**
         * The configuration of the editor.
         * See https://ckeditor.com/docs/ckeditor5/latest/api/module_core_editor_editorconfig-EditorConfig.html
         * to learn more.
         */
        this.config = {};
        //  EX: @Input() public config: CKEditor5.Config = {
        //    // plugins: [FontColor, ],
        //    fontColor: {
        //      colors: [
        //        {
        //          color: 'hsl(0, 0%, 0%)',
        //          label: 'Black'
        //        },
        //        {
        //          color: 'hsl(0, 0%, 30%)',
        //          label: 'Dim grey'
        //        },
        //        {
        //          color: 'hsl(0, 0%, 60%)',
        //          label: 'Grey'
        //        },
        //        {
        //          color: 'hsl(0, 0%, 90%)',
        //          label: 'Light grey'
        //        },
        //        {
        //          color: 'hsl(0, 0%, 100%)',
        //          label: 'White',
        //          hasBorder: true
        //        },
        //        // ...
        //      ]
        //    },
        //    fontBackgroundColor: {
        //      colors: [
        //        {
        //          color: 'hsl(0, 75%, 60%)',
        //          label: 'Red'
        //        },
        //        {
        //          color: 'hsl(30, 75%, 60%)',
        //          label: 'Orange'
        //        },
        //        {
        //          color: 'hsl(60, 75%, 60%)',
        //          label: 'Yellow'
        //        },
        //        {
        //          color: 'hsl(90, 75%, 60%)',
        //          label: 'Light green'
        //        },
        //        {
        //          color: 'hsl(120, 75%, 60%)',
        //          label: 'Green'
        //        },
        //        // ...
        //      ]
        //    },
        //    toolbar: [
        //      'heading', 'bulletedList', 'numberedList', 'fontColor', 'fontBackgroundColor', 'undo', 'redo'
        //    ]
        //  }
        this._value = '';
        this.valueChange = new EventEmitter();
        this.value$ = new BehaviorSubject(this._value);
        /**
         * Fires when the editor is ready. It corresponds with the `editor#ready`
         * https://ckeditor.com/docs/ckeditor5/latest/api/module_core_editor_editor-Editor.html#event-ready
         * event.
         */
        this.ready = new EventEmitter();
        /**
         * Fires when the content of the editor has changed. It corresponds with the `editor.model.document#change`
         * https://ckeditor.com/docs/ckeditor5/latest/api/module_engine_model_document-Document.html#event-change
         * event.
         */
        this.change = new EventEmitter();
        /**
         * Fires when the editing view of the editor is blurred. It corresponds with the `editor.editing.view.document#blur`
         * https://ckeditor.com/docs/ckeditor5/latest/api/module_engine_view_document-Document.html#event-event:blur
         * event.
         */
        this.blur = new EventEmitter();
        /**
         * Fires when the editing view of the editor is focused. It corresponds with the `editor.editing.view.document#focus`
         * https://ckeditor.com/docs/ckeditor5/latest/api/module_engine_view_document-Document.html#event-event:focus
         * event.
         */
        this.focus = new EventEmitter();
        /**
         * Fires when the editor component crashes.
         */
        this.error = new EventEmitter();
        const cfgExtraPlugin = this.config.extraPlugins || [];
        if (!cfgExtraPlugin.includes(RxNxcUploadAdapterPlugin)) {
            cfgExtraPlugin.push(RxNxcUploadAdapterPlugin);
            this.config.extraPlugins = cfgExtraPlugin;
        }
        this.config.RxNxcSetting = {
            uploadUrl: `http://localhost:3000/Webapi/v1/ckeditor-img-upload`,
            uploadKeyName: 'upload-drqa-files',
            uploadReqHeaders: {
                //  'Content-Type': 'application/json',
                //  'X-CSRF-TOKEN': 'CSRF-Token',
                // 10年token
                //  "expiredDatetime": "2031-04-18T07:13:46.954Z",
                Authorization: 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEwMCIsIm5hbWUiOiJBcHDmk43kvZzlk6EiLCJlbWFpbCI6InJlYWxzdW4uNWdoaXNAZ21haWwuY29tIiwicm9sZSI6InVzZXIiLCJhbGxSb2xlcyI6W10sImV4cGlyZXNJbiI6MzE1MzYwMDAwLCJpYXQiOjE2MTg5MDI4MjYsImV4cCI6MTkzNDI2MjgyNn0.PRCuF322kEGcNnhT2Zy65O7czxtwZPdpSclisgFHllAsCSZQQr0fw5nuSYUgeR0QZDxPd8kPM1KPVPZJ6VOGFXq-RV08E8jxVOaagBLdx_heNfRYLHwRcHuCIt4J5XfPu4ZycRVFHOvQQHlRXivd0Zz7v8iVZWQpxycTJU-LQT903ne5sepYQsrruIPkNu-8mexhSkO3qA7JEP44dymhmA-MIePQ_hnsDdWnZNDDgRmj4pYmn0MUpMtKnX1jJBha4pSxrGdxA-40RP_PU2a22b8MBqLTClVCt11FkFcexV0GJMsj0diEgi70Kksq97NOrxecXRfHt4Azy5AkmYwzKw',
                __realsun_doctorId: 'a0002',
                __realsun_doctorName: 'WANG-SHO-MING22',
                multerUploadType: 'DRQA'
            }
        };
    }
    setValue(v) {
        if (this._value != v) {
            this._value = v;
            this.valueChange.emit(v);
            this.value$.next(v);
        }
    }
    valueOb() {
        return this.value$.asObservable();
    }
    get uploadUrl() { return this._uploadUrl; }
    set uploadUrl(v) {
        this._uploadUrl = v;
        const setting = this.config.RxNxcSetting || {};
        setting.uploadUrl = this._uploadUrl;
        this.config.RxNxcSetting = setting;
    }
    get doctorId() { return this._doctorId; }
    set doctorId(v) {
        this._doctorId = v;
        const setting = this.config.RxNxcSetting || {};
        setting.uploadReqHeaders = setting.uploadReqHeaders || {};
        setting.uploadReqHeaders.__realsun_doctorId = this._doctorId;
        this.config.RxNxcSetting = setting;
    }
    get doctorName() { return this._doctorName; }
    set doctorName(v) {
        this._doctorName = v;
        const setting = this.config.RxNxcSetting || {};
        setting.uploadReqHeaders = setting.uploadReqHeaders || {};
        setting.uploadReqHeaders.__realsun_doctorName = this._doctorName;
        this.config.RxNxcSetting = setting;
    }
    getEditor() {
        // Warning: This may return "undefined" if the editor is hidden behind the `*ngIf` directive or
        // if the editor is not fully initialised yet.
        return this.editorComponent.editorInstance;
    }
    ngOnInit() {
        // const cfgExtraPlugin: any[] = this.config.extraPlugins || [];
        // if (!cfgExtraPlugin.includes(RxNxcUploadAdapterPlugin)) {
        //   cfgExtraPlugin.push(RxNxcUploadAdapterPlugin);
        //   this.config.extraPlugins = cfgExtraPlugin;
        // }
        // this.config.RxNxcSetting = {
        //   uploadUrl : `http://localhost:3000/Webapi/v1/ckeditor-img-upload`,
        //   uploadKeyName : 'upload-drqa-files',
        //   uploadReqHeaders : {
        //       //  'Content-Type': 'application/json',
        //       //  'X-CSRF-TOKEN': 'CSRF-Token',
        //       // 10年token
        //       //  "expiredDatetime": "2031-04-18T07:13:46.954Z",
        //       Authorization: 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEwMCIsIm5hbWUiOiJBcHDmk43kvZzlk6EiLCJlbWFpbCI6InJlYWxzdW4uNWdoaXNAZ21haWwuY29tIiwicm9sZSI6InVzZXIiLCJhbGxSb2xlcyI6W10sImV4cGlyZXNJbiI6MzE1MzYwMDAwLCJpYXQiOjE2MTg5MDI4MjYsImV4cCI6MTkzNDI2MjgyNn0.PRCuF322kEGcNnhT2Zy65O7czxtwZPdpSclisgFHllAsCSZQQr0fw5nuSYUgeR0QZDxPd8kPM1KPVPZJ6VOGFXq-RV08E8jxVOaagBLdx_heNfRYLHwRcHuCIt4J5XfPu4ZycRVFHOvQQHlRXivd0Zz7v8iVZWQpxycTJU-LQT903ne5sepYQsrruIPkNu-8mexhSkO3qA7JEP44dymhmA-MIePQ_hnsDdWnZNDDgRmj4pYmn0MUpMtKnX1jJBha4pSxrGdxA-40RP_PU2a22b8MBqLTClVCt11FkFcexV0GJMsj0diEgi70Kksq97NOrxecXRfHt4Azy5AkmYwzKw',
        //       __realsun_doctorId: 'a0002',
        //       __realsun_doctorName: 'WANG-SHO-MING22',
        //       multerUploadType: 'DRQA'
        //   }
        // };
        this.config.RxNxcInst = this;
        // setTimeout(() => {
        //   const toolbars = Array.from(this.getEditor().ui.componentFactory.names());
        //   console.log("TCL-MESSAGE ~ file: rx-nxc-ckeditor.component.ts ~ line 197 ~ RxNxcCkeditorComponent ~ setTimeout ~ toolbars", toolbars, this.getEditor().plugins, this.getEditor().config);
        //   // 結果
        //   // toolbar: ['selectAll', 'undo', 'redo', 'bold', 'italic', 'blockQuote', 'link', 'ckfinder', 'uploadImage', 'imageUpload', 'heading', 'imageTextAlternative', 'toggleImageCaption', 'imageStyle:inline', 'imageStyle:alignLeft', 'imageStyle:alignRight', 'imageStyle:alignCenter', 'imageStyle:alignBlockLeft', 'imageStyle:alignBlockRight', 'imageStyle:block', 'imageStyle:side', 'imageStyle:wrapText', 'imageStyle:breakText', 'indent', 'outdent', 'numberedList', 'bulletedList', 'mediaEmbed', 'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells', 'fontFamily', 'fontSize', 'fontColor', 'fontBackgroundColor']
        // }, 1000);
    }
    onReady(event) {
        this.ready.emit(event);
    }
    onChange(event) {
        // setTimeout(() => {
        //   const { editor } = event ;
        //   if (editor){
        //     const data = editor.getData();
        //     //console.log('onChange settimeout data:', data );
        //     //this.valueChange.emit(this.value);
        //     this.setValue(data);
        //     this.valueChange.emit(data);
        //   }
        // }, 300);
        this.valueChange.emit(this.value);
        // console.log('TCL-MESSAGE ~ file: rx-nxc-ckeditor.component.ts ~ line 126 ~ RxNxcCkeditorComponent ~ onChange ~ this.value', this.value);
        this.change.emit(event);
    }
    onFocus(event) {
        this.focus.emit(event);
    }
    onBlur(event) {
        this.blur.emit(event);
    }
    onError(event) {
        this.error.emit(event);
    }
}
RxNxcCkeditorComponent.ɵfac = function RxNxcCkeditorComponent_Factory(t) { return new (t || RxNxcCkeditorComponent)(); };
RxNxcCkeditorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RxNxcCkeditorComponent, selectors: [["lib-rx-nxc-ckeditor"]], viewQuery: function RxNxcCkeditorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.editorComponent = _t.first);
    } }, inputs: { config: "config", uploadUrl: "uploadUrl", doctorId: "doctorId", doctorName: "doctorName", value: "value", disabled: "disabled" }, outputs: { valueChange: "valueChange", ready: "ready", change: "change", blur: "blur", focus: "focus", error: "error" }, decls: 2, vars: 4, consts: [[3, "editor", "ngModel", "config", "disabled", "ngModelChange", "ready", "change", "focus", "error", "blur"], ["editor", ""]], template: function RxNxcCkeditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ckeditor", 0, 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function RxNxcCkeditorComponent_Template_ckeditor_ngModelChange_0_listener($event) { return ctx.value = $event; })("ready", function RxNxcCkeditorComponent_Template_ckeditor_ready_0_listener($event) { return ctx.onReady($event); })("change", function RxNxcCkeditorComponent_Template_ckeditor_change_0_listener($event) { return ctx.onChange($event); })("focus", function RxNxcCkeditorComponent_Template_ckeditor_focus_0_listener($event) { return ctx.onFocus($event); })("error", function RxNxcCkeditorComponent_Template_ckeditor_error_0_listener($event) { return ctx.onError($event); })("blur", function RxNxcCkeditorComponent_Template_ckeditor_blur_0_listener($event) { return ctx.onBlur($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("editor", ctx.Editor)("ngModel", ctx.value)("config", ctx.config)("disabled", ctx.disabled);
    } }, directives: [ɵngcc1.CKEditorComponent, ɵngcc2.NgControlStatus, ɵngcc2.NgModel], encapsulation: 2 });
RxNxcCkeditorComponent.ctorParameters = () => [];
RxNxcCkeditorComponent.propDecorators = {
    editorComponent: [{ type: ViewChild, args: ['editor',] }],
    config: [{ type: Input }],
    value: [{ type: Input }],
    valueChange: [{ type: Output }],
    disabled: [{ type: Input }],
    uploadUrl: [{ type: Input }],
    doctorId: [{ type: Input }],
    doctorName: [{ type: Input }],
    ready: [{ type: Output }],
    change: [{ type: Output }],
    blur: [{ type: Output }],
    focus: [{ type: Output }],
    error: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RxNxcCkeditorComponent, [{
        type: Component,
        args: [{
                selector: 'lib-rx-nxc-ckeditor',
                template: `
        <ckeditor #editor
          [editor]="Editor"
          [(ngModel)]="value"
          [config]="config"
          [disabled]="disabled"
          (ready)="onReady($event)"
          (change)="onChange($event)"
          (focus)="onFocus($event)"
          (error)="onError($event)"
          (blur)="onBlur($event)"
        >
        </ckeditor>

  `
            }]
    }], function () { return []; }, { config: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], ready: [{
            type: Output
        }], change: [{
            type: Output
        }], blur: [{
            type: Output
        }], focus: [{
            type: Output
        }], error: [{
            type: Output
        }], uploadUrl: [{
            type: Input
        }], doctorId: [{
            type: Input
        }], doctorName: [{
            type: Input
        }], editorComponent: [{
            type: ViewChild,
            args: ['editor']
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

class RxNxcCkeditorModule {
    /**
     *
     * @param myCustomCKEditor
     * import * as myCustomCKEditor from '@realsun/rx-nxc-ckeditor/3rd/build/ckeditor.js';
     * imports: [
     *  BrowserModule,
     *  FormsModule,
     *  RxNxcCkeditorModule.forRoot(myCustomCKEditor)
     * @returns
     */
    static forRoot(myCustomCKEditor) {
        if (!window['RsCustomCKEditor']) {
            window['RsCustomCKEditor'] = myCustomCKEditor;
        }
        return {
            ngModule: RxNxcCkeditorModule,
        };
    }
}
RxNxcCkeditorModule.ɵfac = function RxNxcCkeditorModule_Factory(t) { return new (t || RxNxcCkeditorModule)(); };
RxNxcCkeditorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: RxNxcCkeditorModule });
RxNxcCkeditorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            CKEditorModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RxNxcCkeditorModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    RxNxcCkeditorComponent
                ],
                imports: [
                    FormsModule,
                    CKEditorModule
                ],
                exports: [
                    RxNxcCkeditorComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RxNxcCkeditorModule, { declarations: function () { return [RxNxcCkeditorComponent]; }, imports: function () { return [FormsModule,
        CKEditorModule]; }, exports: function () { return [RxNxcCkeditorComponent]; } }); })();

/*
 * Public API Surface of rx-nxc-ckeditor
 */

/**
 * Generated bundle index. Do not edit.
 */

export { RxNxcCkeditorComponent, RxNxcCkeditorModule, RxNxcCkeditorService };

